// Фокус продукту: запчастини на китайські авто та електромобілі (особливо
// Nissan Leaf). Клієнт фільтрує каталог цими предикатами для кнопок
// «Китайські» / «Електро» і простого режиму — самі дані (снапшот/Dexie)
// не змінюються, тож фокус завжди можна зняти.
import { normalizeText } from './stem.js';
import { CHINESE_MAKE_NAMES, EV_MODELS_BY_MAKE } from './makes.js';
/** Марки без ДВЗ: будь-яке оголошення по них вважаємо електро. */
const EV_ONLY_MAKES = new Set(['tesla', 'zeekr', 'nio', 'xpeng', 'lixiang']);
/**
 * Сигнали електромобільності в тексті (заголовок+опис). Підмножина ключів
 * parts-ev із parts-classifier: без загальних слів типу «перетворювач»,
 * щоб не підтягувати звичайні оголошення з ДВЗ. Розширено EV-сленгом за
 * реальними заголовками OLX/RIA (barter-010). Текст нормалізується
 * (пунктуація → пробіл), тож ключі пишуться як у нормалізованому вигляді
 * («li ion», не «li-ion»), а короткі латинські зигзаги типу «bms» не
 * додаються — підрядком ловлять «Parsun T2.6CBMS».
 */
const EV_TEXT_KEYWORDS = [
    'ввб',
    'високовольтн',
    'высоковольтн',
    'батарея',
    'батарейн',
    'li ion',
    'літій іонн',
    'литиев',
    'зарядн',
    'електромотор',
    'электромотор',
    'електродвигун',
    'електродвигатель',
    'электродвигатель',
    'електрокар',
    'электрокар',
    'електромобіл',
    'электромобил',
    'чадемо',
    'chademo',
    'ccs',
    'nacs',
    'gbt',
    'type 2',
    'soh',
];
export function isChineseAd(ad) {
    return !!ad.make && CHINESE_MAKE_NAMES.has(normalizeText(ad.make));
}
export function isEvMakeModel(make, model) {
    if (!make || !model)
        return false;
    if (EV_ONLY_MAKES.has(normalizeText(make)))
        return true;
    const names = EV_MODELS_BY_MAKE.get(normalizeText(make));
    if (!names)
        return false;
    const norm = normalizeText(model);
    // власний імпорт пише сирі рядки з ERP типу «Leaf ZE1» / «MODEL S 85»
    for (const name of names) {
        if (norm === name || norm.startsWith(`${name} `))
            return true;
    }
    return false;
}
export function isEvAd(ad) {
    if (ad.categoryId === 'parts-ev')
        return true;
    if (isEvMakeModel(ad.make, ad.model))
        return true;
    const haystack = normalizeText(`${ad.title} ${ad.description ?? ''}`);
    return EV_TEXT_KEYWORDS.some((k) => haystack.includes(k));
}
export function isFocusAd(ad) {
    return isChineseAd(ad) || isEvAd(ad);
}
//# sourceMappingURL=focus.js.map